const cena = { t: 'Cena', type: 'range-slider', name: 'cena', unit: 'zł', hint: { url: '/price' }}
export default cena